import { render, staticRenderFns } from "./ClientRoles.vue?vue&type=template&id=56749b93&"
import script from "./ClientRoles.vue?vue&type=script&lang=ts&"
export * from "./ClientRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports